<template>
  <b-card>
    <!-- media -->
    <b-media class="align-items-center" no-body>
      <b-media-aside >
        <b-link>
          <img
            v-if="optionsLocal.avatar == '$body.avatar'"
            height="40"
            class="rounded"
            src="https://wr1.com.vn/wp-content/uploads/2022/05/WR1-logo-220621.png"
          />
          <b-img
            v-else
            ref="previewEl"
            rounded
            :src="optionsLocal.avatar"
            height="80"
          />
        </b-link>
        <!--/ avatar -->
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <!-- upload button -->
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75 round"
          @click="$refs.refInputEl.$el.click()"
        >
          {{ $t("upload") }}
        </b-button>
        <b-form-file
          ref="refInputEl"
          type="file"
          accept="image/*"
          :hidden="true"
          plain
          @change="handleImage"
        />
        <!--/ upload button -->

        <!-- reset -->
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          size="sm"
          class="mb-75 mr-75 round"
          @click.prevent="resetImage"
        >
          {{ $t("reset") }}
        </b-button>
        <!--/ reset -->
        <small v-show="imageError" class="text-danger d-block">{{
          imageError
        }}</small>

        <b-card-text> {{ $t("textUpload") }} </b-card-text>
      </b-media-body>
    </b-media>
    <!--/ media -->

    <!-- form -->
    <b-form class="mt-2">
      <validation-observer ref="simpleRules">
        <b-row>
          <b-col sm="6">
            <b-form-group :label="$t('userName')" label-for="account-id-login">
              <b-form-input
                v-model="optionsLocal.username"
                disabled
                :name="$t('userName')"
              />
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="$t('companyName')"
              label-for="account-company-name"
            >
              <b-form-input
                v-model="optionsLocal.companyName"
                :name="$t('companyName')"
                disabled
              />
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="$t('contactName')"
              label-for="account-company-name"
            >
              <b-form-input
                v-model="optionsLocal.fullName"
                :name="$t('contactName')"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group :label="$t('gender')">
              <b-row class="pw-1">
                <b-col cols="4">
                  <b-form-radio v-model="optionsLocal.genderId" value="1">
                    {{ $t("Male") }}
                  </b-form-radio>
                </b-col>
                <b-col cols="4">
                  <b-form-radio v-model="optionsLocal.genderId" value="2">
                    {{ $t("Female") }}
                  </b-form-radio>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('taxCode')" label-for="account-tax-code">
              <b-form-input v-model="optionsLocal.taxCode" disabled />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('Address')" label-for="account-address">
              <b-form-input
                v-model="optionsLocal.address"
                :title="optionsLocal.address"
                name="address"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <validation-provider
              :name="$t('phone')"
              #default="{ errors }"
              rules="regex:^([0-9]+)$"
            >
              <b-form-group>
                <label>{{ $t("phone") }}</label>
                <b-form-input
                  v-model="optionsLocal.mobile"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('placeholderPhone')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              :name="$t('email')"
              #default="{ errors }"
              rules="email"
            >
              <b-form-group>
                <label>{{ $t("email") }} </label>
                <b-form-input
                  :state="errors.length > 0 ? false : null"
                  v-model="optionsLocal.email"
                  :placeholder="$t('placeholderEmail')"
                />
                <small v-show="errors.length > 0" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('salesman')" label-for="account-sales">
              <b-form-input
                v-model="optionsLocal.sale"
                disabled
                name="Salesman"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('passport')"
              label-for="account-identity-card"
            >
              <b-form-input
                v-model="optionsLocal.idCard"
                name="Identity card"
              />
            </b-form-group>
          </b-col>

          <b-col sm="6">
            <b-form-group
              :label="$t('bankAccount')"
              label-for="account-back-account"
            >
              <b-form-input
                v-model="optionsLocal.bankAccount"
                name="Bank Account"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group :label="$t('bankName')" label-for="account-back-name">
              <!-- <b-form-input v-model="optionsLocal.bankCode" name="Bank Name" /> -->
              <Select2 v-model="optionsLocal.bankCode" :options="bankOptions" />
            </b-form-group>
          </b-col>
          <!-- alert -->
          <!-- <b-col cols="12" class="mt-75">
          <b-alert show variant="warning" class="mb-50">
            <h4 class="alert-heading">
              Your email is not confirmed. Please check your inbox.
            </h4>
            <div class="alert-body">
              <b-link class="alert-link"> Resend confirmation </b-link>
            </div>
          </b-alert>
        </b-col> -->
          <!--/ alert -->

          <b-col cols="12" class="d-flex justify-content-center">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-2 mr-1 round"
              style="min-width: 170px"

              @click.prevent="submitForm"
            >
              {{ $t("saveChanges") }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              style="min-width: 170px"
              variant="outline-secondary"
              type="reset"
              class="mt-2 round"
              @click.prevent="resetForm"
            >
              {{ $t("reset") }}
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </b-card>
</template>

<script>
import { required, email } from "@validations";

import {
  BFormFile,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BAlert,
  BCard,
  BCardText,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BImg,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import useJwt from "@/auth/jwt/useJwt";
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    Select2,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    generalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      bankOptions: [],
      imageError: "",
    };
  },

  methods: {
    resetForm() {
      this.optionsLocal = JSON.parse(JSON.stringify(this.generalData));
    },
    resetImage() {
      this.optionsLocal.avatar = JSON.parse(
        JSON.stringify(this.generalData)
      ).avatar;
    },
    submitForm() {
      event.preventDefault();
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          useJwt
            .put("user/changeProfile", {
              avatar: this.optionsLocal.avatar,
              bankAccount: this.optionsLocal.bankAccount,
              bankCode: this.optionsLocal.bankCode,
              email: this.optionsLocal.email,
              idCard: this.optionsLocal.idCard,
              mobile: this.optionsLocal.mobile,
            })
            .then((response) => {
              if (response.data.result == "emailExists") {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$i18n.t("error"),
                    icon: "XIcon",
                    variant: "danger",
                    text: this.$i18n.t("emailExist"),
                  },
                });
              } else {
                localStorage.setItem(
                  "userData",
                  JSON.stringify(this.optionsLocal)
                );

                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: this.$i18n.t("success"),
                    icon: "CheckIcon",
                    variant: "success",
                    text: this.$i18n.t("updateSuccessProfile"),
                  },
                });
              }
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("error"),
                  icon: "XIcon",
                  variant: "danger",
                  text: this.$i18n.t("errorSystem"),
                },
              });
            });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("notifyFormError"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        }
      });
    },
    handleImage(e) {
      this.imageError = "";
      const seletedImage = e.target.files[0];
      const MAX_SIZE = 2048576;
      if (seletedImage.size > MAX_SIZE) {
        this.imageError = this.$i18n.t("imageSizeProfile");
        return;
      }

      if (
        (seletedImage && seletedImage["type"] === "image/jpeg") ||
        seletedImage["type"] === "image/png"
      ) {
        this.createBase64Image(seletedImage);
      } else {
        this.imageError = this.$i18n.t("imageFileUpload");
      }
    },
    createBase64Image(fileObject) {
      if (window.FileReader) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.optionsLocal.avatar = e.target.result;
        };
        reader.readAsDataURL(fileObject);
      }
    },
  },
  mounted() {
    useJwt
      .get("masterData", { params: { data: "Bank" } })
      .then((response) => {
        const mapBanks = response.data.result.map((obj) => {
          obj.text = obj.code + " | " + obj.name;
          obj.id = obj.code;
          return obj;
        });
        this.bankOptions = mapBanks;
      })
      .catch((error) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("errorSystem"),
            icon: "XIcon",
            variant: "danger",
          },
        });
      });
  },
};
</script>


<style>
.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}
.select2-selection__arrow {
  background: none;
  display: none !important;
}
</style>